import React, { useEffect, useState, useContext, useMemo } from 'react';
import classnames from 'classnames';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { Calendar as CalendarIcon } from 'lucide-react';
import { LocaleContext } from 'providers/locale-settings-context';
import InputWithLeadingIcon from './forms/InputWithLeadingIcon';

const monthMask = [/[0-1]/, /[0-9]/];
const dayMask = [/[0-3]/, /[0-9]/];
const yearMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

const DATE_SEPARATOR = '/';

const dateMask = [
  ...monthMask,
  DATE_SEPARATOR,
  ...dayMask,
  DATE_SEPARATOR,
  ...yearMask,
];

const internationalDateMask = [
  ...dayMask,
  DATE_SEPARATOR,
  ...monthMask,
  DATE_SEPARATOR,
  ...yearMask,
];

export default function CustomDateInput({
  value,
  onChange,
  alwaysShowMask,
  disabled,
  className,
  dataTestId,
  ...props
}) {
  const localeContext = useContext(LocaleContext);
  const dateFormat = localeContext?.localeData?.dateFormat;
  function getMask() {
    if (dateFormat?.startsWith('DD')) {
      return internationalDateMask;
    }
    return dateMask;
  }

  const [mask, setMask] = useState(getMask());

  useEffect(() => {
    if (!dateFormat.startsWith('DD')) {
      // Conditional mask for the 2nd digit base on the first digit
      if ((value || '').startsWith('1')) {
        setMask([dateMask[0], /[0-2]/, ...dateMask.slice(2)]);
      } else {
        setMask([...dateMask]);
      }
    }
  }, [value]);

  function handleChange(e) {
    onChange(e);
  }

  return (
    <InputMask
      mask={mask}
      value={value}
      alwaysShowMask={alwaysShowMask}
      disabled={disabled}
      data-testid={dataTestId}
      {...props}
      onChange={handleChange}
    >
      <InputWithLeadingIcon
        dataTestId="InputWithLeadingIcon-b550aaa0"
        value={value}
        className={className}
        passEventOnChange
      >
        <CalendarIcon className="w-4 h-4" />
      </InputWithLeadingIcon>
    </InputMask>
  );
}

CustomDateInput.props = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  alwaysShowMask: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
};

CustomDateInput.defaultProps = {
  alwaysShowMask: true,
  disabled: false,
};
